import { IsString } from 'class-validator';

export class ChangePasswordModel {
  @IsString()
  declare currentPassword: string;

  @IsString()
  declare newPassword: string;
}
